// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-multidataset .g-dialog-body {
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
}
.dialog-multidataset .g-dialog-footer {
  width: 704px;
  float: right;
}
.dialog-multidataset__left {
  width: 256px;
  height: 720px;
  float: left;
  background: var(--g-color-base-generic-ultralight);
  padding: 28px 0 0;
}
.dialog-multidataset__left-header {
  padding-left: 24px;
  font-size: 18px;
  margin-bottom: 16px;
}
.dialog-multidataset__left-dataset {
  padding-left: 24px;
  line-height: 32px;
  height: 32px;
  vertical-align: middle;
}
.dialog-multidataset__left-dataset-icon {
  float: left;
  margin-right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  width: 24px;
  color: var(--g-color-base-positive-heavy);
  margin-top: 4px;
}
.dialog-multidataset__left-dataset-title {
  width: 150px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dialog-multidataset__left-dataset-more {
  float: right;
  margin-right: 24px;
}
.dialog-multidataset__left-dataset-more svg {
  margin-top: 1px;
}
.dialog-multidataset__left-dataset.dataset-add {
  opacity: 0.5;
}
.dialog-multidataset__left-dataset-add-icon {
  margin-top: 7px;
  float: left;
  margin-right: 8px;
}
.dialog-multidataset__left-dataset:hover {
  background: var(--dl-color-contrast-4);
  cursor: pointer;
}
.dialog-multidataset__right {
  width: 704px;
  height: 628px;
  float: right;
  overflow-y: auto;
  padding: 32px 0 0 40px;
}
.dialog-multidataset__right-header {
  font-size: 15px;
  margin-bottom: 16px;
}
.dialog-multidataset__right-link {
  width: 450px;
}
.dialog-multidataset__right-link {
  margin-top: 16px;
}
.dialog-multidataset__right-link-formula {
  display: inline-block;
  background: var(--g-color-base-info-light);
  border: 1px solid var(--g-color-base-info-light);
  border-radius: 4px;
  padding: 6px 12px;
}
.dialog-multidataset__right-link-formula span {
  display: inline-block;
}
.dialog-multidataset__right-link-formula div {
  display: inline-block;
}
.dialog-multidataset__right-link-formula-field {
  margin: 0 0 0 4px;
  opacity: 0.5;
}
.dialog-multidataset__right-link-formula-dataset {
  color: var(--g-color-text-info);
}
.dialog-multidataset__right-link-formula-equal {
  margin: 0 8px;
}
.dialog-multidataset__right-link-formula:hover {
  cursor: pointer;
  background: var(--g-color-base-info-light);
}`, "",{"version":3,"sources":["webpack://./src/ui/units/wizard/components/Dialogs/DialogMultidataset.scss"],"names":[],"mappings":"AACI;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAAR;AAGI;EACI,YAAA;EACA,YAAA;AADR;AAII;EACI,YAAA;EACA,aAAA;EACA,WAAA;EACA,kDAAA;EAEA,iBAAA;AAHR;AAKQ;EACI,kBAAA;EACA,eAAA;EACA,mBAAA;AAHZ;AAMQ;EACI,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,sBAAA;AAJZ;AAMY;EACI,WAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,yCAAA;EACA,eAAA;AAJhB;AAOY;EACI,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AALhB;AAQY;EACI,YAAA;EACA,kBAAA;AANhB;AAQgB;EACI,eAAA;AANpB;AAUY;EACI,YAAA;AARhB;AAWY;EACI,eAAA;EACA,WAAA;EACA,iBAAA;AAThB;AAYY;EACI,sCAAA;EACA,eAAA;AAVhB;AAeI;EACI,YAAA;EACA,aAAA;EACA,YAAA;EAEA,gBAAA;EAEA,sBAAA;AAfR;AAiBQ;EACI,eAAA;EACA,mBAAA;AAfZ;AAkBQ;EACI,YAAA;AAhBZ;AAmBQ;EACI,gBAAA;AAjBZ;AAmBY;EACI,qBAAA;EACA,0CAAA;EACA,gDAAA;EACA,kBAAA;EACA,iBAAA;AAjBhB;AAmBgB;EACI,qBAAA;AAjBpB;AAoBgB;EACI,qBAAA;AAlBpB;AAqBgB;EACI,iBAAA;EACA,YAAA;AAnBpB;AAsBgB;EACI,+BAAA;AApBpB;AAuBgB;EACI,aAAA;AArBpB;AAwBgB;EACI,eAAA;EACA,0CAAA;AAtBpB","sourcesContent":[".dialog-multidataset .g-dialog-body {\n  padding-left: 0;\n  padding-right: 0;\n  padding-top: 0;\n}\n.dialog-multidataset .g-dialog-footer {\n  width: 704px;\n  float: right;\n}\n.dialog-multidataset__left {\n  width: 256px;\n  height: 720px;\n  float: left;\n  background: var(--g-color-base-generic-ultralight);\n  padding: 28px 0 0;\n}\n.dialog-multidataset__left-header {\n  padding-left: 24px;\n  font-size: 18px;\n  margin-bottom: 16px;\n}\n.dialog-multidataset__left-dataset {\n  padding-left: 24px;\n  line-height: 32px;\n  height: 32px;\n  vertical-align: middle;\n}\n.dialog-multidataset__left-dataset-icon {\n  float: left;\n  margin-right: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 24px;\n  width: 24px;\n  color: var(--g-color-base-positive-heavy);\n  margin-top: 4px;\n}\n.dialog-multidataset__left-dataset-title {\n  width: 150px;\n  display: inline-block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.dialog-multidataset__left-dataset-more {\n  float: right;\n  margin-right: 24px;\n}\n.dialog-multidataset__left-dataset-more svg {\n  margin-top: 1px;\n}\n.dialog-multidataset__left-dataset.dataset-add {\n  opacity: 0.5;\n}\n.dialog-multidataset__left-dataset-add-icon {\n  margin-top: 7px;\n  float: left;\n  margin-right: 8px;\n}\n.dialog-multidataset__left-dataset:hover {\n  background: var(--dl-color-contrast-4);\n  cursor: pointer;\n}\n.dialog-multidataset__right {\n  width: 704px;\n  height: 628px;\n  float: right;\n  overflow-y: auto;\n  padding: 32px 0 0 40px;\n}\n.dialog-multidataset__right-header {\n  font-size: 15px;\n  margin-bottom: 16px;\n}\n.dialog-multidataset__right-link {\n  width: 450px;\n}\n.dialog-multidataset__right-link {\n  margin-top: 16px;\n}\n.dialog-multidataset__right-link-formula {\n  display: inline-block;\n  background: var(--g-color-base-info-light);\n  border: 1px solid var(--g-color-base-info-light);\n  border-radius: 4px;\n  padding: 6px 12px;\n}\n.dialog-multidataset__right-link-formula span {\n  display: inline-block;\n}\n.dialog-multidataset__right-link-formula div {\n  display: inline-block;\n}\n.dialog-multidataset__right-link-formula-field {\n  margin: 0 0 0 4px;\n  opacity: 0.5;\n}\n.dialog-multidataset__right-link-formula-dataset {\n  color: var(--g-color-text-info);\n}\n.dialog-multidataset__right-link-formula-equal {\n  margin: 0 8px;\n}\n.dialog-multidataset__right-link-formula:hover {\n  cursor: pointer;\n  background: var(--g-color-base-info-light);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
